import DamagePhotoModal from "./damage-photo-modal";

import "./damage-modals.scss";


const DamageModals = {
    Photo  : DamagePhotoModal
}

export default DamageModals;